import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { HttpClient } from '@angular/common/http';
import {SdirparamstateModel} from '../sdirparamstate/sdirparamstate.model';
import {map} from 'rxjs/operators';
import {SdirobjectstateModel} from '../sdirobjectstate/sdirobjectstate.model';
import {ParamstateModel} from '../paramstate/paramstate.model';
import {ObjecttypeModel} from '../objecttype/objecttype.model';


export const SDIR_IMAGES = {
  1: 'new.svg',
  2: 'pnr.svg',
  4: 'failure.svg',
  5: 'oe.svg',
  3: 'prom.svg'
};


@Injectable()
export class DatasetApiService {

  constructor(private http: HttpClient) {
  }

  // Эти функции надо кэшировать
  getSdirparamstate(): Observable<SdirparamstateModel[]> {
    // return this.http.get<SdirparamstateModel[]>('/db/sdirparamstate');
    return this.http.get<SdirparamstateModel[]>('/paramsysstate');
  }

  getSysParamstates(): Observable<SdirparamstateModel[]> {
    // return this.http.get<SdirparamstateModel[]>('/db/sdirparamstate');
    return this.http.get<SdirparamstateModel[]>('/paramsysstate');
  }

  getParamstates(): Observable<ParamstateModel[]> {
    // return this.http.get<SdirparamstateModel[]>('/db/sdirparamstate');
    return this.http.get<ParamstateModel[]>('/paramstate');
  }


  getSdirobjectstate(): Observable<SdirobjectstateModel[]> {
    return this.http.get<SdirobjectstateModel[]>('/db/sdirobjectstate').pipe(map((response: SdirobjectstateModel[]) => {
      return response.map(val => {
        val.image = SDIR_IMAGES[val.id];
        if (val.image) {
          val.image = 'scopes/' + val.image;
        }
        return val;
      });
    }));
  }
  getObjecttypes(): Observable<ObjecttypeModel[]> {
    return this.http.get<ObjecttypeModel[]>('/objecttype').pipe(map((response: ObjecttypeModel[]) => {
      return response.map(val => {
        return val;
      });
    }));
  }


  getParamtags(): Observable<Object[]> {
    return this.http.get<Object[]>('/db/paramtag');
  }

}
